'use client';
import React from 'react';
import {Box, Stack} from '@mui/material';
import Image from 'next/image';
import WildsLaunchContainer from '../WaldorfContainer';
import ParallaxText from '@components/ParallaxText';
import ReactHtmlParser from '@libs/reactHtmlParser';
import cn from './style.module.scss';
import ParallaxBlock from '@components/ParallaxBlock';
interface WaldorfBackdropProps {
  welcomeRightGraphicsImage: any;
  welcomeLeftGraphicsImage: any;
  t: any;
}
export default function WaldorfBackdrop(props: WaldorfBackdropProps) {
  const {t} = props;
  return (
    <Box component='section' className={cn.waldorfBackdropWrapper}>
      <Box className={cn.waldorfWelcomeRightGraphics}>
        <Image
          src={props.welcomeRightGraphicsImage.url}
          unoptimized
          quality={100}
          alt='image'
          width={768}
          height={768}
        />
      </Box>
      <Stack className={cn.waldorfBackdropInner}>
        <WildsLaunchContainer>
          <Box className={cn.waldorfBackdropBlock}>
            <ParallaxBlock animationType='zoomIn' animationDuration={800}>
              <Box className={cn.waldorfBackdropBlock__heading}>
                <h3>{ReactHtmlParser(t['waldorfBackdropHeading'])}</h3>
              </Box>
            </ParallaxBlock>
            <Box className={cn.waldorfBackdropBlock__text}>
              <ParallaxText
                variant='body1'
                animationType='slideInBottom'
                animationDuration={800}>
                {ReactHtmlParser(t['waldorfBackdropContent'])}
              </ParallaxText>
            </Box>
          </Box>
        </WildsLaunchContainer>
      </Stack>
      <Box className={cn.waldorfWelcomeLeftGraphics}>
        <Image
          src={props.welcomeLeftGraphicsImage.url}
          unoptimized
          quality={100}
          alt='image'
          width={768}
          height={768}
        />
      </Box>
    </Box>
  );
}
